// Synthesized cosmic ambient pad using the Web Audio API. No external assets.
let ctx = null;
let master = null;
let nodes = [];
let lfoTimer = null;
let running = false;

const CHORD = [110, 164.81, 220, 329.63]; // A2, E3, A3, E4 — open, celestial

function ensureCtx() {
  if (!ctx) {
    const AC = window.AudioContext || window.webkitAudioContext;
    ctx = new AC();
    master = ctx.createGain();
    master.gain.value = 0;
    master.connect(ctx.destination);
  }
  return ctx;
}

export async function startAmbient(targetVolume = 0.12) {
  ensureCtx();
  if (ctx.state === "suspended") await ctx.resume();
  if (running) {
    master.gain.cancelScheduledValues(ctx.currentTime);
    master.gain.linearRampToValueAtTime(targetVolume, ctx.currentTime + 2);
    return;
  }
  running = true;

  const filter = ctx.createBiquadFilter();
  filter.type = "lowpass";
  filter.frequency.value = 650;
  filter.Q.value = 0.6;
  filter.connect(master);

  CHORD.forEach((freq, i) => {
    const osc = ctx.createOscillator();
    osc.type = i % 2 === 0 ? "sine" : "triangle";
    osc.frequency.value = freq;
    osc.detune.value = (Math.random() - 0.5) * 8;

    const g = ctx.createGain();
    g.gain.value = 0.18 / CHORD.length;

    // slow amplitude shimmer per voice
    const lfo = ctx.createOscillator();
    lfo.frequency.value = 0.04 + Math.random() * 0.06;
    const lfoGain = ctx.createGain();
    lfoGain.gain.value = 0.06;
    lfo.connect(lfoGain);
    lfoGain.connect(g.gain);

    osc.connect(g);
    g.connect(filter);
    osc.start();
    lfo.start();
    nodes.push(osc, lfo);
  });

  // gentle filter sweep for movement
  lfoTimer = setInterval(() => {
    if (!ctx) return;
    const t = ctx.currentTime;
    const target = 450 + Math.random() * 500;
    filter.frequency.linearRampToValueAtTime(target, t + 6);
  }, 6000);
  nodes.push(filter);

  master.gain.cancelScheduledValues(ctx.currentTime);
  master.gain.setValueAtTime(master.gain.value, ctx.currentTime);
  master.gain.linearRampToValueAtTime(targetVolume, ctx.currentTime + 3);
}

export function stopAmbient() {
  if (!ctx || !running) return;
  const t = ctx.currentTime;
  master.gain.cancelScheduledValues(t);
  master.gain.setValueAtTime(master.gain.value, t);
  master.gain.linearRampToValueAtTime(0, t + 1.5);
  setTimeout(() => {
    nodes.forEach((n) => {
      try { n.stop && n.stop(); } catch {}
      try { n.disconnect && n.disconnect(); } catch {}
    });
    nodes = [];
    if (lfoTimer) clearInterval(lfoTimer);
    lfoTimer = null;
    running = false;
  }, 1600);
}

export function isAmbientRunning() {
  return running;
}
